import TokenData from '../components/common/TokenData';

export const REQUEST_CONNECT_USER = 'REQUEST_CONNECT_USER';
export const RECEIVE_CONNECT_USER = 'RECEIVE_CONNECT_USER';
export const FAIL_CONNECT_USER = 'FAIL_CONNECT_USER';
export const SET_ERROR = 'SET_ERROR';
export const GET_INFO_FROM_URL = 'GET_INFO_FROM_URL';
export const REQUEST_LINK_USER = 'REQUEST_LINK_USER';
export const RECEIVE_LINK_USER = 'RECEIVE_LINK_USER';
export const FAIL_LINK_USER = 'FAIL_LINK_USER';

export const setError = description => {
  return {
    type: SET_ERROR,
    errorFlag: true,
    description: description
  };
};

export const getInfoFromURL = queryInfo => {
  return {
    type: GET_INFO_FROM_URL,
    queryInfo: queryInfo,
    tokenData: new TokenData(queryInfo.t),
    errorFlag: false,
    description: null
  };
};

export const requestConnectUser = () => {
  return {
    type: REQUEST_CONNECT_USER,
    isRequestingUser: true
  };
};

export const receiveConnectUser = json => {
  return {
    type: RECEIVE_CONNECT_USER,
    isRequestingUser: false,
    json: json
  };
};


export const requestLinkUser = () => {
  return {
    type: REQUEST_LINK_USER,
    isRequestingUser: true
  };
};

export const receiveLinkUser = json => {
  return {
    type: RECEIVE_LINK_USER,
    isRequestingUser: false,
    json: json
  };
};

